import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

// ✅ Convert HTML to plain text
const htmlToText = (html = "") => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
  } catch {
    return (html || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
  }
};

// ✅ Make excerpt with ellipsis only if needed
const makeExcerpt = (html = "", limit = 75) => {
  const text = htmlToText(html);
  if (text.length <= limit) return { excerpt: text, isLong: false };
  return { excerpt: `${text.slice(0, limit).trimEnd()}…`, isLong: true };
};

function BubbleAvatarReviews() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [reviewsData, setReviewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getReviewsData();
  }, []);

  const getReviewsData = async () => {
    try {
      setIsLoading(true);
      const response = await SendPostRequest("reviews");
      setReviewsData(Array.isArray(response?.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviewsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  return (
    <>
      {isLoading ? (
        <div className="d-flex justify-content-center mt-5">
          <Spinner />
        </div>
      ) : reviewsData?.length === 0 ? (
        <div className="text-center mt-5">No Reviews Available</div>
      ) : (
        <div className="container">
          <div className="row mb-5 pb-3">
            <div className="offset-md-2 col-md-8">
              <div className="title-wrap text-center">
                <div className="section-title margin-bottom-60">
                  <h2 className="section-title mb-0 text-uppercase mt-5">
                    Patient <span className="theme-color">Reviews</span>
                  </h2>
                  <span className="section-border-bottom center"></span>
                </div>
              </div>
            </div>

            <div className="col-md-12 testimonails" data-animation="fadeInRight">
              <OwlCarousel
                className="owl-carousel testimonial-style-6 dark-switch"
                loop
                nav={false}
                dots={false}
                autoplay={true}
                autoplayHoverPause
                autoplayTimeout={3000}
                smartSpeed={250}
                margin={30}
                items={3}
                responsive={{
                  0: { items: 1 },
                  768: { items: 2 },
                  1024: { items: 3 },
                }}
              >
                {reviewsData.map((data, index) => {
                  const { excerpt, isLong } = makeExcerpt(data?.detail, 75);

                  return (
                    <div className="item animated fadeInRight visible" key={data?.id || index}>
                      <div className="TestimonialStyle3">
                        <div className="testimonial-inner">
                          <div className="testimonial-details text-center">
                            <div className="client-details">
                              <div className="client-image">
                                <img
                                  className="img-circle b-radius-50"
                                  src={data?.profile_image || "/assets/img/no-image.png"}
                                  style={{ width: "80px", height: "80px" }}
                                  alt={data?.full_name || "reviewer"}
                                />
                              </div>
                            </div>

                            <div className="testimonial-description margin-top-15">
                              <p className="mb-3 pb-1">
                                {excerpt}{" "}
                                {isLong && (
                                  <Link
                                    to="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleShowMore(data);
                                    }}
                                    className="fw-bold"
                                  >
                                    See More
                                  </Link>
                                )}
                              </p>
                            </div>

                            <div className="client-info ms-3">
                              <h5 className="mb-0 text-uppercase">{data?.full_name}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </OwlCarousel>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Modal for full review */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedReview && (
            <div
              dangerouslySetInnerHTML={{
                __html: selectedReview?.detail || "",
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BubbleAvatarReviews;
